
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vector-nti",
      function () {
        return require("private-next-pages/vector-nti.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vector-nti"])
      });
    }
  